{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "search": "Search",
    "loading": "Loading…",
    "yes": "Yes",
    "no": "No",
    "close": "Close",
    "submit": "Submit",
    "back": "Back",
    "previous": "Previous",
    "next": "Next",
    "confirm": "Confirm",
    "select": "Select…",
    "reset": "Reset",
    "ok": "OK",
    "export": "Export",
    "create": "Create",
    "add": "Add",
    "remove": "Remove",
    "refresh": "Refresh",
    "clear": "Clear",
    "apply": "Apply",
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "filter": "Filter",
    "more": "More",
    "update": "Update",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "clone": "Clone",
    "schedule": "Schedule",
    "publish": "Publish",
    "submitForApproval": "Submit for approval",
    "send": "Send",
    "start": "Start",
    "assign": "Assign",
    "archive": "Archive",
    "reply": "Reply",
    "lock": "Lock",
    "reopen": "Reopen",
    "continue": "Continue",
    "verify": "Verify",
    "goLive": "Go Live",
    "use": "Use",
    "selectItem": "Select",
    "addLine": "Add line",
    "connect": "Connect",
    "reconnect": "Reconnect",
    "disconnect": "Disconnect",
    "configure": "Configure",
    "refreshing": "Refreshing…"
  },
  "status": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Info"
  },
  "company": {
    "language": "Language",
    "country": "Country",
    "currency": "Currency",
    "timezone": "Timezone",
    "code": "Code",
    "name": "Name",
    "default": "Default",
    "label": "Company",
    "workingIn": "Working in {{name}}",
    "loading": "Loading companies…",
    "select": "Select company",
    "chooseTitle": "Select a company",
    "chooseSubtitle": "You have access to more than one company. Choose one to continue.",
    "continue": "Continue",
    "noAccessTitle": "No company access",
    "noAccessSubtitle": "Your account is not linked to any company yet. Please contact your administrator."
  },
  "viewMode": {
    "list": "List",
    "calendar": "Calendar",
    "hierarchy": "Hierarchy",
    "label": "View mode"
  },
  "table": {
    "search": "Search…",
    "searchAria": "Search table",
    "noRecords": "No records found",
    "noData": "No data",
    "export": "Export",
    "pageOf": "Page {{page}} of {{total}}",
    "totalCount": "{{count}} total",
    "previousPage": "Previous page",
    "nextPage": "Next page"
  },
  "dialog": {
    "confirm": "Confirm",
    "cancel": "Cancel",
    "value": "Value"
  },
  "picker": {
    "selectDate": "Select date",
    "selectTime": "Select time",
    "selectDateTime": "Select date & time",
    "hour": "Hour",
    "minute": "Minute",
    "from": "From",
    "to": "To",
    "selectDays": "Select days",
    "noDaysSelected": "No days selected",
    "noMatches": "No matches",
    "search": "Search…"
  },
  "layout": {
    "favorites": "Favorites",
    "recent": "Recent",
    "applications": "Your applications",
    "products": "Your products",
    "pickWorkspace": "Pick a workspace to open",
    "enabledApps": "Only apps enabled for your organization",
    "searching": "Searching…",
    "noMatches": "No matches",
    "markAllRead": "Mark all read",
    "clearAll": "Clear all",
    "clearing": "Clearing…",
    "noNotifications": "No notifications yet",
    "upgradeRequired": "Upgrade your plan to unlock",
    "upgradeTooltip": "{{label}} (upgrade required)",
    "currentApp": "Current app",
    "switchApp": "Switch app",
    "switchAppTooltip": "Switch app · {{label}}",
    "switchAppAria": "Switch app, current: {{label}}",
    "switchApplication": "Switch application",
    "apps": "Apps"
  },
  "commandPalette": {
    "ariaLabel": "Search",
    "placeholder": "Search pages, customers, products, leads…",
    "placeholderModule": "Search pages and records in this module…",
    "close": "Close search",
    "searching": "Searching…",
    "noMatches": "No matches"
  },
  "form": {
    "field": "Field",
    "value": "Value",
    "addField": "Add field"
  },
  "toast": {
    "switchedToModule": "Switched to {{label}}"
  },
  "errors": {
    "failedToLoadCompanyOverview": "Failed to load company overview",
    "youDoNotHaveAccessToThisApplication": "You do not have access to this application",
    "couldNotSwitchWorkspace": "Could not switch workspace",
    "failedToLoadRoles": "Failed to load roles",
    "failedToLoadEmployees": "Failed to load employees",
    "failedToLoadCustomers": "Failed to load customers",
    "failedToLoadSuppliers": "Failed to load suppliers",
    "failedToLoadProducts": "Failed to load products",
    "failedToLoadProjects": "Failed to load projects",
    "failedToLoadSocialAccounts": "Failed to load social accounts",
    "failedToLoadWorkQueue": "Failed to load work queue",
    "failedToLoadPurchaseOrders": "Failed to load purchase orders",
    "failedToLoadPurchaseRequests": "Failed to load purchase requests",
    "failedToLoadRfqs": "Failed to load RFQs",
    "failedToLoadStores": "Failed to load stores",
    "failedToChangePassword": "Failed to change password",
    "couldNotLoadMfaStatus": "Could not load MFA status",
    "couldNotStartMfaSetup": "Could not start MFA setup",
    "invalidAuthenticatorCode": "Invalid authenticator code",
    "couldNotSaveNotificationPreferences": "Could not save notification preferences",
    "moduleNotEnabled": "The {{module}} module is not enabled for this organization",
    "loadListFailed": "Failed to load list"
  },
  "access": {
    "pagePermissionDenied": "You do not have permission to view this page.",
    "pageNotAvailableForRole": "This page is not available for your role.",
    "pageNotAvailableInModule": "This page is not available in your current module.",
    "posTerminalPermissionDenied": "You do not have permission to use the POS terminal.",
    "featureNotEnabled": "Feature not enabled: {{featureCode}}. Upgrade your subscription to unlock."
  },
  "select": {
    "noProducts": "No products found",
    "noEmployees": "No employees found",
    "noCustomers": "No customers found",
    "noSuppliers": "No suppliers found",
    "noStores": "No stores found",
    "noProjects": "No projects found",
    "noCourses": "No courses found",
    "noShifts": "No shifts found",
    "noDepartments": "No departments found",
    "noDesignations": "No designations found",
    "noGrades": "No grades found",
    "noBusinessUnits": "No business units found",
    "noPurchaseOrders": "No purchase orders found",
    "noPurchaseRequests": "No purchase requests found",
    "noRfqs": "No RFQs found",
    "noLeaveTypes": "No leave types — configure them in HR Master data",
    "noShiftTypes": "No shift types — configure them in HR Master data",
    "noEmploymentTypes": "No employment types — configure them in HR Master data",
    "noExpenseTypes": "No expense types — configure them in HR Master data",
    "noDocumentTypes": "No document types — configure them in HR Master data",
    "noOvertimeTypes": "No overtime types available — defaults are created automatically on first use",
    "searchProduct": "Search product by name or SKU…",
    "searchProductDetail": "Search by name, SKU, or barcode…",
    "none": "None",
    "noManager": "No manager",
    "selectEmployee": "Select employee",
    "selectCustomer": "Select customer",
    "selectSupplier": "Select supplier",
    "selectSuppliers": "Search and select suppliers…",
    "selectLeaveType": "Select leave type",
    "selectPurchaseRequestOptional": "Select purchase request (optional)",
    "selectEmployees": "Select employees…",
    "selectProject": "Select project",
    "searchPurchaseOrder": "Search purchase order…",
    "selectManager": "Select manager",
    "selectEmploymentType": "Select employment type",
    "selectShiftType": "Select shift type",
    "selectDepartment": "Select department",
    "selectDesignation": "Select designation",
    "selectGrade": "Select grade",
    "selectBusinessUnit": "Select business unit",
    "selectExpenseType": "Select expense type",
    "selectDocumentType": "Select document type",
    "selectShift": "Select shift",
    "selectStore": "Select store",
    "selectCourse": "Select course",
    "searchRfq": "Search RFQ…",
    "selectOvertimeType": "Select overtime type",
    "selectProduct": "Select product",
    "selectCountry": "Select country",
    "selectCurrency": "Select currency",
    "selectTimezone": "Select timezone",
    "selectLanguage": "Select language",
    "searchAndSelectEmployees": "Search and select employees…",
    "searchEmployee": "Search by code, name, or email…",
    "searchEmploymentTypes": "Search employment types…",
    "searchShiftTypes": "Search shift types…",
    "searchDepartments": "Search departments…",
    "searchDesignations": "Search designations…",
    "searchGrades": "Search grades…",
    "searchBusinessUnits": "Search business units…",
    "searchLeaveTypes": "Search leave types…",
    "searchCustomers": "Search customers…",
    "searchOvertimeTypes": "Search overtime types…",
    "searchSuppliers": "Search suppliers…",
    "searchSuppliersDetail": "Search suppliers by name, email, GST…",
    "searchPoNumber": "Search by PO number…",
    "searchProjects": "Search projects…",
    "searchRequestNumber": "Search by request number…",
    "searchShifts": "Search shifts…",
    "searchCourses": "Search courses…",
    "searchDocumentTypes": "Search document types…",
    "searchStores": "Search stores by name or code…",
    "searchRfqNumber": "Search by RFQ number…",
    "searchCountries": "Search countries…",
    "searchCurrencies": "Search currencies…",
    "searchTimezones": "Search timezones…",
    "searchLanguages": "Search languages…",
    "searchExpenseTypes": "Search expense types…",
    "searchProductBarcode": "Search name, SKU, or scan barcode…",
    "searchBills": "Search bills…",
    "searchMasterAdmins": "Search master admins…",
    "searchEmailName": "Search email, name…",
    "loadingStores": "Loading stores…",
    "noCountries": "No countries found",
    "noCurrencies": "No currencies found",
    "noTimezones": "No timezones found",
    "noLanguages": "No languages found"
  },
  "placeholders": {
    "all": "All",
    "name": "Name",
    "code": "Code",
    "email": "Email",
    "port": "Port",
    "amount": "Amount",
    "value": "Value",
    "any": "Any",
    "reply": "Reply…",
    "addTag": "Add tag",
    "noFileChosen": "No file chosen",
    "chooseFile": "Choose file",
    "eG1": "e.g. 1",
    "eG10": "e.g. 10",
    "eG50": "e.g. 50",
    "eG100": "e.g. 100",
    "percentRange": "0–100",
    "loading": "Loading…",
    "dash": "—",
    "weightUnit": "Weight ({{unit}})"
  },
  "preferences": {
    "appearance": "Appearance",
    "appearanceDesc": "Switch between light and dark mode. Your choice is saved on this device.",
    "light": "Light",
    "dark": "Dark",
    "sampleGuides": "Sample guides",
    "sampleGuidesDesc": "Walk through example flows to learn each module — no production data is changed.",
    "language": "Language",
    "languageDesc": "Choose your interface language. By default, your company's language is used.",
    "useCompanyLanguage": "Use company language",
    "languageSaved": "Language preference saved",
    "languageSaveFailed": "Could not save language preference",
    "companyLanguageHint": "Company default: {{language}}",
    "timezone": "Display timezone",
    "timezoneDesc": "Override your company timezone for dates and times shown to you. Business rules continue to use the company timezone.",
    "timezoneOverride": "Use a personal display timezone",
    "displayTimezone": "Personal timezone",
    "companyTimezone": "Company default",
    "effectiveTimezone": "Currently displayed in",
    "usingCompanyTimezone": "Personal override is off. Your active company's timezone is used.",
    "timezoneSaved": "Timezone preference saved",
    "timezoneSaving": "Saving timezone preference",
    "timezoneSaveFailed": "Could not save timezone preference",
    "timezoneRefreshFailed": "Timezone was saved, but the session could not be refreshed",
    "timezoneRequired": "Select an active timezone before enabling the override"
  },
  "security": {
    "twoFactorTitle": "Two-factor authentication",
    "twoFactorDesc": "Add an extra layer of protection when signing in.",
    "passwordTitle": "Password",
    "passwordDesc": "Use a strong password with at least 8 characters.",
    "updatePassword": "Update password",
    "required": "Required",
    "passwordMin8": "At least 8 characters",
    "passwordsMismatch": "Passwords must match",
    "loadingSettings": "Loading security settings…",
    "mfaProtectDesc": "Protect your account with a 6-digit code from Google Authenticator, Microsoft Authenticator, or similar apps.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "mfaSignInPrompt": "You will be asked for an authenticator code each time you sign in.",
    "disableMfa": "Disable two-factor authentication",
    "enableMfa": "Enable two-factor authentication",
    "confirmAndEnable": "Confirm and enable",
    "setupSteps": "Setup steps",
    "setupStep1": "Open your authenticator app.",
    "setupStep2": "Scan the QR code or enter the secret manually.",
    "setupStep3": "Enter the 6-digit code below to confirm.",
    "mfaQrAlt": "MFA QR code",
    "scanQrCode": "Scan the QR code with your authenticator app"
  },
  "notifications": {
    "title": "Notification preferences",
    "description": "Control in-app and email alerts for apps you can access. Approvals apply across your subscribed workflows. All options are on by default. Security emails such as password reset are always sent.",
    "saving": "Saving…",
    "saved": "Saved",
    "emptyCategories": "No notification categories are available for your account yet."
  },
  "profileMenu": {
    "myProfile": "My profile",
    "signOut": "Sign out"
  },
  "pages": {
    "stores": "Stores",
    "warehouses": "Warehouses",
    "headcount": "Headcount",
    "pendingLeave": "Pending leave",
    "openCrmDeals": "Open CRM deals",
    "openCrmLeads": "Open CRM leads",
    "deskTickets": "Desk tickets",
    "openPos": "Open POs",
    "financeAccounts": "Finance accounts",
    "monthStoreSales": "Month store sales",
    "monthInvoices": "Month invoices",
    "payrollRuns": "Payroll runs",
    "accessDenied": "Access Denied",
    "pageNotFound": "Page Not Found",
    "sampleDataGuidedSetup": "Sample data & guided setup",
    "general": "General",
    "yourApplications": "Your applications",
    "approvalsSystemUpdatesAndStockAlerts": "Approvals, system updates, and stock alerts when relevant to your apps.",
    "alertsForTheModulesEnabledFor": "Alerts for the modules enabled for your role."
  },
  "dashboard": {
    "keyMetrics": "Key metrics",
    "metrics": "Metrics",
    "period": {
      "day": "Today",
      "week": "This week",
      "month": "This month",
      "year": "This year"
    },
    "trends": {
      "yearWeek": "Year-week {{label}}",
      "total": "Total",
      "series": {
        "attendance": "Attendance Records",
        "leave-requests": "Leave Requests"
      }
    },
    "companyOverview": {
      "selectCompany": "Select a company in the header to see company-wide KPIs across HR, CRM, desk, procurement, and finance.",
      "description": "Company overview · {{currencyCode}}{{departmentNote}}",
      "departmentLimited": " · limited to {{count}} department(s)"
    },
    "widgets": {
      "hr-headcount": "Head Count",
      "hr-pending-leaves": "Pending Leaves",
      "hr-leave-percent": "Leave %",
      "hr-attendance-records": "Attendance Record",
      "hr-pending-attendance": "Pending Attendance",
      "hr-pending-timesheet": "Pending Timesheet",
      "pos-sales-today": "Sales today",
      "pos-invoices": "Invoices",
      "pos-low-stock": "Low stock alerts",
      "fin-receivables": "Receivables",
      "fin-payables": "Payables",
      "fin-cashflow": "Cash balance",
      "proc-open-pr": "Open PRs",
      "proc-pending-po": "Pending POs",
      "crm-pipeline": "Pipeline value",
      "crm-leads": "New leads",
      "wh-open-picks": "Open picks",
      "wh-transfers": "Transfers",
      "wh-cycle-counts": "Cycle counts",
      "desk-open-tickets": "Open tickets",
      "desk-sla-breach": "SLA breaches",
      "proj-active": "Active projects",
      "proj-overdue": "Overdue tasks",
      "mkt-campaigns": "Campaigns",
      "mkt-sent": "Emails sent",
      "soc-inbox": "Inbox",
      "soc-scheduled": "Scheduled posts",
      "lg-leads": "New leads",
      "lg-forms": "Active forms",
      "org-summary": "Organization summary",
      "org-notifications": "Notifications"
    }
  },
  "labels": {
    "user": "User",
    "selectEmployeeWithLogin": "Select employee with login…",
    "addUser": "Add user",
    "mapUsers": "Map Users",
    "selectEmployeeWithLogin2": "Select employee with login",
    "selectEmployeesWithLogin": "Select employees with login…",
    "dashboardPeriod": "Dashboard period",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "copyPassword": "Copy password",
    "removeLine": "Remove line",
    "toggleSidebar": "Toggle sidebar",
    "searchCtrlK": "Search (Ctrl+K)",
    "closeNotifications": "Close notifications",
    "accountMenu": "Account menu",
    "workspaceNavigation": "Workspace navigation",
    "clearSelection": "Clear selection",
    "searchScreens": "Search screens",
    "screenNameOrRoute": "Screen name or route",
    "authenticatorCode": "Authenticator code",
    "verificationCode": "Verification code",
    "enterCodeToDisableMfa": "Enter code to disable MFA",
    "actionSettings": "Action settings",
    "calendar": "Calendar",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "hour": "Hour",
    "minute": "Minute",
    "noFileChosen": "No file chosen",
    "removeFile": "Remove file",
    "field": "Field",
    "fieldName": "Field name",
    "value": "Value",
    "customFieldName": "Custom field name",
    "customField": "Custom field…",
    "selectField": "Select field",
    "eGCountry": "e.g. country",
    "eGProductcode": "e.g. productCode",
    "closeDialog": "Close dialog",
    "selectCountry": "Select country",
    "searchCountryOrCode": "Search country or code…",
    "clearAllSelections": "Clear all selections",
    "loadingTable": "Loading table",
    "loadingPage": "Loading page",
    "loadingDashboard": "Loading dashboard",
    "inApp": "In-app",
    "email": "Email",
    "theme": "Theme",
    "currentPassword": "Current password",
    "confirmNewPassword": "Confirm new password",
    "dismissNotification": "Dismiss notification",
    "expandQuickStartChecklist": "Expand quick start checklist",
    "quickStartChecklist": "Quick start checklist",
    "minimizeQuickStart": "Minimize quick start",
    "dismissQuickStart": "Dismiss quick start",
    "openSidebar": "Open sidebar",
    "closeSidebar": "Close sidebar"
  },
  "tooltips": {
    "automationAction": "Configure what happens when this automation runs."
  },
  "actionConfig": {
    "addSetting": "Add setting",
    "fields": {
      "message": "Message",
      "channel": "Channel",
      "assigneeId": "Assignee ID",
      "taskTitle": "Task title",
      "status": "Status",
      "issueTitle": "Issue title",
      "description": "Description"
    },
    "placeholders": {
      "notificationText": "Notification text",
      "emailOrInApp": "email or in-app",
      "employeeOrUserId": "Employee or user ID",
      "optionalTitle": "Optional title",
      "statusExample": "e.g. IN_PROGRESS",
      "summary": "Summary",
      "details": "Details"
    },
    "gateway": {
      "credentials": "Gateway credentials",
      "keyId": "Key ID",
      "keySecret": "Key secret",
      "publishableKey": "Publishable key",
      "secretKey": "Secret key",
      "merchantId": "Merchant ID",
      "apiKey": "API key",
      "apiSecret": "API secret",
      "clientKeyId": "Client / key ID",
      "secret": "Secret",
      "merchantIdOptional": "Merchant ID (optional)"
    }
  },
  "matchCriteria": {
    "title": "Match criteria",
    "hint": "All listed fields must match for this rule to apply. Leave empty to match any lead.",
    "addCriterion": "Add criterion",
    "country": "Country",
    "state": "State / province",
    "region": "Region",
    "industry": "Industry",
    "companySize": "Company size",
    "leadSource": "Lead source",
    "productInterest": "Product interest",
    "placeholders": {
      "country": "e.g. IN, US",
      "state": "e.g. MH, CA",
      "region": "e.g. APAC",
      "industry": "e.g. technology",
      "companySize": "e.g. Enterprise",
      "leadSource": "e.g. WEBSITE",
      "product": "e.g. ERP"
    }
  },
  "tour": {
    "steps": {
      "POS": {
        "store": {
          "title": "Create a store",
          "description": "Set up your first retail location.",
          "actionLabel": "Open stores"
        },
        "product": {
          "title": "Add products",
          "description": "Build your catalog with prices and tax rules.",
          "actionLabel": "Add product"
        },
        "customer": {
          "title": "Add customers",
          "description": "Register customers for loyalty and invoicing.",
          "actionLabel": "Add customer"
        },
        "sale": {
          "title": "Record a sale",
          "description": "Complete your first transaction on the POS terminal.",
          "actionLabel": "Open POS"
        },
        "reports": {
          "title": "View reports",
          "description": "Track performance and sales trends.",
          "actionLabel": "View reports"
        }
      },
      "CRM": {
        "lead": {
          "title": "Create a lead",
          "description": "Capture prospects from the Leads workspace.",
          "actionLabel": "Open leads"
        },
        "convert": {
          "title": "Convert lead",
          "description": "Qualify and convert a lead to a contact or deal.",
          "actionLabel": "Convert lead"
        },
        "deal": {
          "title": "Create a deal",
          "description": "Track opportunities in your pipeline.",
          "actionLabel": "Create deal"
        },
        "pipeline": {
          "title": "Track pipeline",
          "description": "Move deals through stages on the board.",
          "actionLabel": "Open pipeline"
        }
      },
      "HR": {
        "employee": {
          "title": "Add employee",
          "description": "Create employee profiles under Employees.",
          "actionLabel": "Add employee"
        },
        "attendance": {
          "title": "Configure attendance",
          "description": "Set policies and record attendance.",
          "actionLabel": "Set up attendance"
        },
        "payroll": {
          "title": "Run payroll",
          "description": "Process payroll when your cycle is ready.",
          "actionLabel": "Open payroll"
        }
      }
    }
  },
  "columns": {
    "code": "Code",
    "name": "Name",
    "status": "Status",
    "actions": "Actions",
    "description": "Description",
    "color": "Color",
    "employee": "Employee",
    "shift": "Shift",
    "hours": "Hours",
    "days": "Days",
    "type": "Type",
    "date": "Date",
    "title": "Title",
    "category": "Category",
    "provider": "Provider",
    "active": "Active",
    "location": "Location",
    "email": "Email",
    "role": "Role",
    "amount": "Amount",
    "comments": "Comments",
    "level": "Level",
    "grade": "Grade",
    "start": "Start",
    "end": "End",
    "score": "Score",
    "reason": "Reason",
    "content": "Content",
    "rating": "Rating",
    "reviewer": "Reviewer",
    "cycle": "Cycle",
    "details": "Details",
    "expiry": "Expiry",
    "download": "Download",
    "claim": "Claim",
    "from": "From",
    "to": "To",
    "run": "Run",
    "gross": "Gross",
    "net": "Net",
    "product": "Product",
    "revenue": "Revenue",
    "payment": "Payment",
    "invoiceNumber": "Invoice #",
    "quantitySold": "Qty sold",
    "rate": "Rate %",
    "taxable": "Taxable",
    "tax": "Tax",
    "lines": "Lines",
    "alertQty": "Alert qty",
    "need": "Need",
    "daysLeft": "Days left",
    "invoices": "Invoices",
    "sales": "Sales",
    "organization": "Organization",
    "platforms": "Platforms",
    "paid": "Paid",
    "carryForward": "Carry forward",
    "payrollMode": "Payroll mode",
    "hoursPerDay": "Hours/day",
    "endDateRequired": "End date required",
    "trackExpiry": "Track expiry",
    "receiptRequired": "Receipt required",
    "leaveType": "Leave type",
    "policy": "Policy",
    "annualDays": "Annual days",
    "accrual": "Accrual",
    "maxConsecutive": "Max consecutive",
    "carryForwardMax": "Carry forward max",
    "backdated": "Backdated",
    "nonWorking": "Full day off",
    "workingDays": "Working days",
    "defaultHours": "Default hours",
    "employment": "Employment",
    "headcount": "Headcount",
    "positions": "Positions",
    "position": "Position",
    "relationship": "Relationship",
    "grossAmount": "Gross amount",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "salaryStructure": "Salary structure",
    "structureName": "Structure name",
    "applicableDay": "Applicable day",
    "netAmount": "Net amount",
    "employeeId": "Employee ID",
    "deductions": "Deductions",
    "mode": "Mode",
    "inOut": "In / out",
    "open": "Open",
    "ot": "OT",
    "worked": "Worked",
    "week": "Week",
    "course": "Course",
    "tag": "Tag",
    "nonWorkingDay": "Full day off",
    "returnRequired": "Return required"
  }
}
